import { useQuery } from '@tanstack/react-query'
import { getUnreadCount, messagesQueryKey } from '@/services/messagesService'
import { useAuthStore } from '@/store/authStore'

/**
 * Polling totale messaggi non letti per il badge sidebar.
 * Refetch ogni 10s mentre il tab è in foreground.
 * Ritorna 0 se l'utente non è loggato o è ADMIN (gli admin non hanno chat propria).
 */
export function useUnreadMessages(): number {
  const role = useAuthStore((s) => s.user?.role)
  const enabled = !!role && role !== 'ADMIN'

  const { data } = useQuery({
    queryKey:        messagesQueryKey('client', 'unread'),
    queryFn:         () => getUnreadCount('client'),
    refetchInterval: 10_000,
    enabled,
    staleTime:       5_000,
  })
  return data ?? 0
}

/**
 * Stesso polling per lo scope `peer`: badge «Colleghi e supporto» per
 * l'operatore, badge «Supporto operatori» (casella condivisa) per l'admin.
 * Gli USER non hanno accesso allo scope.
 */
export function useUnreadPeerMessages(): number {
  const role = useAuthStore((s) => s.user?.role)
  const enabled = role === 'OPERATOR' || role === 'ADMIN'

  const { data } = useQuery({
    queryKey:        messagesQueryKey('peer', 'unread'),
    queryFn:         () => getUnreadCount('peer'),
    refetchInterval: 10_000,
    enabled,
    staleTime:       5_000,
  })
  return data ?? 0
}
